<template>
    <div class="generate-item" :class="classes">
        <div class="generate-item__main">
            <div class="generate-item__title">{{title}}</div>
            <div class="generate-item__content" v-html="description"></div>
        </div>
        <div class="generate-item__footer">
            <v-btn class="generate-item__btn" :color="value ? 'info' : 'success'" @click="$emit('input', !value)">{{btnText}}</v-btn>
        </div>
        <i v-if="value" class="material-icons generate-item__icon">done</i>
    </div>
</template>

<script>
    export default {
        components: {},
        data() {
            return {}
        },
        props: {
            title: String,
            description: String,
            value: Boolean
        },
        computed: {
            classes () {
                return {
                    'active': this.value,
                    [`elevation-${this.value ? 1 : 4}`]: true
                }
            },
            btnText () {
                return this.value ? 'Отменить тест' : 'Выбрать тест'
            }
        },
        methods: {}
    }
</script>

<style lang="stylus">
    .generate-item {
        padding 2rem
        margin-bottom 2rem
        position relative

        &.active &__main{
            opacity 0.4
        }
        &__main {
            transition opacity 0.3s
        }

        &__title {
            font-size 1.8rem
            margin-bottom 1rem
        }
        &__content {}
        &__footer {
            display flex
            align-items center
            justify-content flex-end
            margin-top 2rem
        }
        &__icon {
            color #4caf50
            position absolute
            top 1rem
            right 1rem
        }
        &__btn {
            width 14rem
            margin 0
        }
    }
</style>
